import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { Confirmation } from 'src/app/enums/confirmation.enum';

@Component({
  selector: 'fury-content-action',
  templateUrl: './content-action.component.html',
  styleUrls: ['./content-action.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
  encapsulation: ViewEncapsulation.None
})
export class ContentActionComponent implements OnInit {
  homeownerform!: FormGroup;
  imagestoupload: any;
  confirmation = Confirmation;

  constructor(
    @Inject(MAT_DIALOG_DATA) public defaults: any,
    private dialogRef: MatDialogRef<ContentActionComponent>,
    private apiservice: ApiService
  ) { }

  ngOnInit() {
    this.forminit();
    if (this.defaults.homeownerid) {
      this.getHomeownerdetail(this.defaults.homeownerid);
    }
  }

  forminit() {
    this.homeownerform = new FormGroup({
      title: new FormControl('', [Validators.required]),
      image: new FormControl('', [Validators.required]),
      description: new FormControl('', [Validators.required]),
    });
  }

  onImageUpload(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      let ftu;
      ftu = event.target.files[0];
      this.homeownerform.patchValue({ image: ftu });
    }
  }

  getHomeownerdetail(homeownerid: string) {
    this.apiservice.get(`homeowner-hub/${homeownerid}`).subscribe((res: any) => {
      if (res && res.data) {
        this.homeownerform.patchValue({
          title: res.data.title,
          image: res.data.image,
          description: res.data.description
        });
      }
    }, err => {
    });
  }

  edit() {
    if (this.homeownerform.valid) {
      const formdata = new FormData();
      formdata.append('title', this.homeownerform.controls['title'].value.trim());
      formdata.append('description', this.homeownerform.controls['description'].value.trim());
      formdata.append('image', this.homeownerform.controls['image'].value);
      formdata.append('home_owner_id', this.defaults.homeownerid);
      this.apiservice.put('homeowner-hub/update', formdata).subscribe((res: any) => {
        if (res) {
          this.dialogRef.close({
            success: true,
            message: res.message
          });
        }
      }, err => {
        if (err) {
          this.apiservice.alert('Somthing went wrong', 'error');
        }
      });
    } else {
      this.homeownerform.markAllAsTouched();
    }
  }

}
